import React from "react";
import { CalendarClock } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { money, formatPrettyDate, daysFromToday } from "@/lib/dateHelpers";

export default function DashboardStats({ stats, upcoming, onSelectClient }) {
  return (
    <>
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-5">
        <StatCard label="Active Clients" value={stats.active} testid="stat-active" />
        <StatCard label="New Leads" value={stats.leads} testid="stat-leads" />
        <StatCard label="Follow-ups" value={stats.followUps} testid="stat-followups" />
        <StatCard label="This Week" value={stats.weekly} testid="stat-weekly" />
        <StatCard label="Open Balances" value={money(stats.balance)} testid="stat-balance" />
      </div>

      {upcoming.length > 0 && (
        <Card className="rounded-2xl shadow-sm" data-testid="upcoming-sessions">
          <CardContent className="p-5">
            <div className="mb-3 flex items-center gap-2">
              <CalendarClock size={20} className="text-slate-700" />
              <h3 className="text-lg font-bold">Upcoming Sessions</h3>
            </div>
            <div className="flex gap-3 overflow-x-auto pb-1">
              {upcoming.map((c) => {
                const days = daysFromToday(c.nextSession);
                const label = days === 0 ? "Today" : days === 1 ? "Tomorrow" : `In ${days} days`;
                const tone =
                  days === 0
                    ? "bg-amber-50 border-amber-300 text-amber-900"
                    : days <= 2
                      ? "bg-blue-50 border-blue-300 text-blue-900"
                      : "bg-slate-50 border-slate-200 text-slate-800";
                return (
                  <button
                    key={c.id}
                    data-testid={`upcoming-${c.id}`}
                    onClick={() => onSelectClient(c.id)}
                    className={`min-w-[200px] flex-shrink-0 rounded-2xl border p-3 text-left transition hover:shadow-sm ${tone}`}
                  >
                    <p className="text-xs font-semibold uppercase tracking-wide">{label}</p>
                    <p className="mt-1 text-base font-bold">{c.dogName}</p>
                    <p className="text-sm">{c.ownerName}</p>
                    <p className="mt-1 text-xs opacity-80">{formatPrettyDate(c.nextSession)}</p>
                  </button>
                );
              })}
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}

function StatCard({ label, value, testid }) {
  return (
    <Card className="rounded-2xl shadow-sm">
      <CardContent className="p-5">
        <p className="text-sm text-slate-500">{label}</p>
        <p data-testid={testid} className="mt-1 text-3xl font-bold">
          {value}
        </p>
      </CardContent>
    </Card>
  );
}
